import React, { useEffect, useRef, useState } from 'react';
import { StepConfigItem } from '~/Interfaces';
import Step from './components/Step';
import StepFooter from './components/StepFooter';
import ResizeObserver from 'resize-observer-polyfill';
import { Container } from './Stepper.styled';

interface StepperProps {
  currentStepConfig: StepConfigItem;
  stepIsLoading?: boolean;
  currentStep: number;
  extraStepContent?: React.ReactNode;
  footerCTAAction: () => void;
  footerCTALabel: string;
  extraFooterContent?: React.ReactNode;
  fixedFooter?: boolean;
}

const Stepper = ({
  currentStepConfig,
  stepIsLoading,
  currentStep,
  extraStepContent,
  footerCTAAction,
  footerCTALabel,
  extraFooterContent,
  fixedFooter,
}: StepperProps) => {
  const footerRef = useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = useState(100);

  const handleFooterResize = (entries: ResizeObserverEntry[]) => {
    const clientHeight = entries?.[0]?.target?.clientHeight;
    if (clientHeight) {
      setFooterHeight(clientHeight);
    }
  };

  useEffect(() => {
    if (footerRef.current) {
      new ResizeObserver(handleFooterResize).observe(footerRef.current);
    }
  }, [footerRef]);

  return (
    <Container
      $stickyFooter={currentStepConfig.stickyFooter}
      $fullHeight={currentStepConfig.fullHeight}
    >
      <Step
        currentStepConfig={currentStepConfig}
        lockStep={stepIsLoading}
        currentStep={currentStep}
        footerHeight={footerHeight}
        extraStepContent={extraStepContent}
      />
      <StepFooter
        stepIsLoading={stepIsLoading}
        currentStepConfig={currentStepConfig}
        CTAAction={footerCTAAction}
        CTALabel={footerCTALabel}
        footerRef={footerRef}
        extraContent={extraFooterContent}
        fixedFooter={fixedFooter}
      />
    </Container>
  );
};
export default Stepper;
